import { createRouter, type RouterHistory } from '@tanstack/react-router';
import type { RouterContext } from './routes/__root.tsx';
import { routeTree } from './routeTree.gen.ts';
import { ErrorPanel } from './ui/error-boundary.tsx';

export function createAppRouter(context: RouterContext, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
    // Route data comes from TanStack Query, which has its own freshness rules (plan §9).
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ({ error, reset }) => <ErrorPanel error={error} onRetry={reset} />,
    ...(history === undefined ? {} : { history }),
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
